import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  HeaderHLPure,
  ButtonAddHLPure,
  SearchBarHLPure,
  GridPure,
} from "../../pures";
import DialogDeletePermissionPure from "../../pures/dialog-delete-permission/dialog-delete-permission-pure"

import "./groups-administration.css";
import GroupAdministrationAddView from "./groups-administration-add.view";

const GroupAdministrationView = (props) => {
  let {
    permissions,
    showDialogDeletePermission,
    toggleDialogDeletePermission,
    action,
    setAction,
    createPermission,
    editPermission,
    loading,
    loadingUsers,
    getUsersByPermission,
    usersByPermission,
    users,
    deletePermission
    } = props
 
  const { t, i18n } = useTranslation();
  const { t: tCommon } = useTranslation('common');
  const [searchPermission, setSearchPermission] = useState('')
  const [selectedPermission, setSelectedPermission] = useState(null)

  const hideActions = useMediaQuery('(max-width: 820px)');

  const permissionsGrid = useMemo(() => {
    if (!permissions) return [];

    let copyPermissions = [...permissions]
    let newData = copyPermissions.filter((permission) => (
      permission.name.toLowerCase().includes(searchPermission.toLowerCase()) ||
      permission.name.includes(searchPermission.toLowerCase())))
    return newData
  }, [permissions, searchPermission])

  const getHeaderTitle = () => {
    if (!action) return translatedActions.groups;
    return getCurrentTranslatedAction(action);
  };

  // Estado para manejar las acciones traducidas
  const [translatedActions, setTranslatedActions] = useState({
    newGroup: t("groupAdministrationView.newGroup"),
    details: tCommon('details'),
    groups: t("groupAdministrationView.groups")
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [action]);

  useEffect(() => {
    setTranslatedActions({
      newGroup: t("groupAdministrationView.newGroup"),
      details: tCommon('details'),
      groups: t("groupAdministrationView.groups")
    });

    // Si hay una acción establecida, actualízala
    if (action) {
      setAction(getCurrentTranslatedAction(action));
    }
  }, [i18n.language, t, tCommon]);

  // Función para obtener la versión actualizada de una acción
  const getCurrentTranslatedAction = (actionValue) => {
    if (actionValue === translatedActions.newGroup) return t("groupAdministrationView.newGroup");
    if (actionValue === translatedActions.details) return tCommon('details');
    return actionValue; // Para cualquier otro caso
  };

  const handleChangeSearch = (e) => setSearchPermission(e.target.value)

  const handleNewGroup = () => setAction(translatedActions.newGroup);

  const handleDeletePermission = (dataItem) => {
    toggleDialogDeletePermission(true)
    setSelectedPermission(dataItem)
  }

  const handleViewDetails = (dataItem) => {
    setSelectedPermission(dataItem);
    setAction(translatedActions.details);
  };

  const handleBack = () => {
    setSelectedPermission(null)
    setAction(null)
  }

  return (
    <>
      {showDialogDeletePermission && (
        <DialogDeletePermissionPure
          selectedPermission={selectedPermission}
          toggleDialogDeletePermission={toggleDialogDeletePermission}
          deletePermission={deletePermission}
        />
      )}

      {props.loading
        ? <div className='loading'>
          <SimpleLoading />
        </div>
        : (
          <Container className="configurationDomainView">
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <HeaderHLPure title={getHeaderTitle()} />
              </Grid>

              {action ? (
                <Grid item xs={12}>
                  <GroupAdministrationAddView
                    backGrid={handleBack}
                    action={getCurrentTranslatedAction(action)}
                    createPermission={createPermission}
                    selectedPermission={selectedPermission}
                    editPermission={editPermission}
                    toggleDialogDeletePermission={toggleDialogDeletePermission}
                    getUsersByPermission={getUsersByPermission}
                    usersByPermission={usersByPermission}
                    loadingUsers={loadingUsers}
                    users={users}
                  />
                </Grid>
              ) : <>
                <Grid item xs={12} className="add-and-search-container">
                  <ButtonAddHLPure
                    iconAdd={true}
                    nameBtn={t("groupAdministrationView.newGroup")}
                    onClickBtn={handleNewGroup}
                  />

                  <SearchBarHLPure
                    placeholder={t("groupAdministrationView.group.placeholder.search")}
                    onSearchChange={((e) => handleChangeSearch(e))}
                  />
                </Grid>

                <Grid item xs={12}>
                  <GridPure
                    {...props}
                    className="configurationDomainView-grid"
                    dataGrid={permissionsGrid}
                    skip={0}
                    take={6}
                    rowsItems={[{
                      field: 'name',
                      title: t("groupAdministrationView.nameGroup"),
                      sorteable: true
                    },
                    {
                      field: 'description',
                      title: t("groupAdministrationView.group.description"),
                      sorteable: true
                    },
                    {
                      field: 'Acciones',
                      title: tCommon("actions"),
                      actions: true,
                      width: hideActions ? 60 : 200,
                      headerClassName: 'actionHeader'
                    }]}
                    actions={[
                      {
                        type: 'view-details',
                        value: tCommon('details'),
                        onClick: handleViewDetails
                      },
                      {
                        type: 'icon',
                        value: 'k-icon k-i-delete k-i-trash',
                        onClick: handleDeletePermission
                      },
                    ]}
                  />
                </Grid>
              </>}
            </Grid>
          </Container>
        )}
    </>
  );
};

export { GroupAdministrationView as default };
